/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const PageServiceType = new ObjectType({
    name: 'PageServiceItem',
    description: 'Cet objet represente une page service',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la page service',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la page service',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la page service',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la page service',
            resolve: (root) => root.content.rendered
        },
        titreBanniere: {
            type: StringType,
            description: 'Titre Banniere de la page service',
            resolve: (root) => root.acf.titre_banniere
        },
        schema: {
            type: StringType,
            description: 'schema de la page service',
            resolve: (root) => root.acf.schema.url
        },
        schemaLeft: {
            type: StringType,
            description: 'schema gauche de la page service',
            resolve: (root) => root.acf.schema_colonne_gauche
        },
        schemaRight: {
            type: StringType,
            description: 'schema droit de la page service',
            resolve: (root) => root.acf.schema_colonne_droite
        },
        sectionPourquoi: {
            type: StringType,
            description: 'Section pourquoi de la page service',
            resolve: (root) => root.acf.section_pourquoi
        },
        sectionServices: {
            type: StringType,
            description: 'Section service de la page service',
            resolve: (root) => root.acf.section_services
        },
    }),
});

export default PageServiceType;



// WEBPACK FOOTER //
// ./data/types/PageServiceType.js